import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import Logo from "./Logo";

const INTERESTS = [
  { id: "membership", label: "Membership" },
  { id: "information", label: "Just Information" },
];

export default function ComingSoon() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [interests, setInterests] = useState([]);
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const toggle = (id) => setInterests((arr) => (arr.includes(id) ? arr.filter((x) => x !== id) : [...arr, id]));

  const submit = async (e) => {
    e.preventDefault();
    if (interests.length === 0) { toast.error("Please select at least one option."); return; }
    setBusy(true);
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/interest`, { ...form, interests });
      setSent(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong. Please try again.");
    } finally { setBusy(false); }
  };

  return (
    <section className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6 py-16" data-testid="coming-soon-page">
      <div className="w-full max-w-xl text-center">
        <div className="inline-block"><Logo variant="vertical" /></div>
        <div className="hairline my-10 max-w-[80px] mx-auto" />
        <p className="eyebrow">Lake Nona · Orlando</p>
        <h1 className="font-serif text-5xl sm:text-6xl mt-5 leading-[1.05] tracking-tight">
          Coming <span className="italic" style={{ color: "var(--twr-bronze)" }}>soon.</span>
        </h1>
        <p className="text-[var(--twr-warm-white)]/60 mt-6 leading-relaxed">
          A private members club, restaurant, craft cocktail bar, and cigar lounge.
          <br />More details coming soon.
        </p>

        {sent ? (
          <div className="surface p-8 mt-12 text-left" data-testid="interest-success">
            <p className="font-serif text-2xl">You're on the list.</p>
            <p className="text-[var(--twr-warm-white)]/60 text-sm mt-3 leading-relaxed">
              Thank you — we'll be in touch as details are released. Discretion assured.
            </p>
          </div>
        ) : (
          <form onSubmit={submit} className="surface p-8 mt-12 text-left" data-testid="interest-form">
            <p className="eyebrow">Would you like more info?</p>
            <div className="mt-5 flex flex-wrap gap-3">
              {INTERESTS.map((i) => (
                <button
                  key={i.id}
                  type="button"
                  data-testid={`interest-${i.id}`}
                  onClick={() => toggle(i.id)}
                  className={`px-4 py-2.5 text-[11px] tracking-[0.22em] uppercase border transition-colors ${interests.includes(i.id) ? "border-[var(--twr-bronze)] bg-[var(--twr-bronze)] text-[#0A0A0A]" : "border-[var(--twr-line-strong)] text-[var(--twr-warm-white)]/70 hover:border-[var(--twr-bronze)] hover:text-[var(--twr-bronze)]"}`}
                >
                  {interests.includes(i.id) ? "✓ " : ""}{i.label}
                </button>
              ))}
            </div>
            <div className="grid sm:grid-cols-2 gap-4 mt-6">
              <label className="block">
                <span className="eyebrow">Name *</span>
                <input data-testid="interest-name" required value={form.name} onChange={(e) => set("name", e.target.value)}
                  className="mt-2 w-full bg-transparent border border-[var(--twr-line-strong)] focus:border-[var(--twr-bronze)] outline-none px-3 py-3 text-sm" />
              </label>
              <label className="block">
                <span className="eyebrow">Email *</span>
                <input data-testid="interest-email" type="email" required value={form.email} onChange={(e) => set("email", e.target.value)}
                  className="mt-2 w-full bg-transparent border border-[var(--twr-line-strong)] focus:border-[var(--twr-bronze)] outline-none px-3 py-3 text-sm" />
              </label>
            </div>
            <label className="block mt-4">
              <span className="eyebrow">Phone</span>
              <input data-testid="interest-phone" value={form.phone} onChange={(e) => set("phone", e.target.value)}
                className="mt-2 w-full bg-transparent border border-[var(--twr-line-strong)] focus:border-[var(--twr-bronze)] outline-none px-3 py-3 text-sm" />
            </label>
            <label className="block mt-4">
              <span className="eyebrow">Anything you'd like us to know?</span>
              <textarea data-testid="interest-message" rows={2} value={form.message} onChange={(e) => set("message", e.target.value)}
                className="mt-2 w-full bg-transparent border border-[var(--twr-line-strong)] focus:border-[var(--twr-bronze)] outline-none px-3 py-3 text-sm" />
            </label>
            <button disabled={busy} data-testid="interest-submit" className="btn-bronze w-full mt-6">
              {busy ? "Sending…" : "Request Info"}
            </button>
          </form>
        )}
        <p className="text-[var(--twr-warm-white)]/35 text-[11px] mt-10 tracking-[0.22em] uppercase">The Win Room · Est. 2026</p>
      </div>
    </section>
  );
}
